import { render, staticRenderFns } from "./Fixd.vue?vue&type=template&id=44424e59&scoped=true&"
import script from "./Fixd.vue?vue&type=script&lang=js&"
export * from "./Fixd.vue?vue&type=script&lang=js&"
import style0 from "./Fixd.vue?vue&type=style&index=0&id=44424e59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44424e59",
  null
  
)

export default component.exports